import WeakIterable                              from "@/prototype/utils/WeakIterable.js";
import {json_set_path, json_apply_modifications} from "@/prototype/utils/JSON.js";

import global from "@/prototype/global.js";

import Generic from "./Generic.js";

import {Observable} from "object-observer";

const log = global.log.getLogger("f_mtac.scene.objects.json.layer");
log.setLevel(log.levels.WARN);

const Layer = function(name) {
    var objects = {};
    var group = Observable.from({});
    const object_delete_handler = new WeakIterable();
    const object_create_handler = new WeakIterable();
    const object_update_handler = new WeakIterable();
    Object.defineProperties(this, {
        objects: {
            set: () => {},
            get: () => objects
        },
        group: {
            set: () => {},
            get: () => group
        },
        ids: {
            set: () => {},
            get: () => Object.keys(objects)
        },
        empty: {
            set: () => {},
            get: () => (Object.keys(objects).length === 0)
        },
        type: {
            set: () => {},
            get: () => "json"
        }
    });

    const create_handler = (local_id, new_object) => {
        for (let handler of object_create_handler) {
            handler(local_id, new_object);
        }
    };

    const update_handler = (local_id, old_object, new_object) => {
        for (let handler of object_update_handler) {
            handler(local_id, old_object, new_object);
        }
    };

    const delete_handler = (local_id, old_object) => {
        for (let handler of object_delete_handler) {
            handler(local_id, old_object);
        }
    };

    const changes_handler = (changes) => {
        var old_object = {}, new_object = {}, root = false;
        for (let {type, path, value, oldValue} of changes) {
            let path_str = path.join(".");
            root = root || (path.length === 1);
            log.info(`json layer ${name} mutation ${type} on path ${path_str} ${oldValue} -> ${value}`);
            switch(type) {
            case "insert":
                json_set_path(new_object, path_str, value);
                break;
            case "update":
                json_set_path(old_object, path_str, oldValue);
                json_set_path(new_object, path_str, value);
                break;
            case "delete":
                json_set_path(old_object, path_str, oldValue);
                break;
            default:
                log.warn(`unhandled type of event received ${type}`, {type, path, value, oldValue});
                break;
            }
        }
        for (let local_id in old_object) {
            if (local_id in new_object) {
                update_handler(local_id, old_object[local_id], new_object[local_id]);
                delete new_object[local_id];
            } else {
                if (root) {
                    delete_handler(local_id, old_object[local_id]);
                } else {
                    update_handler(local_id, old_object[local_id], {});
                }
            }
            delete old_object[local_id];
        }
        for (let local_id in new_object) {
            if (root) {
                create_handler(local_id, new_object[local_id]);
                delete old_object[local_id];
            } else {
                update_handler(local_id, {}, new_object[local_id]);
                delete new_object[local_id];
            }
        }

    };
    group.observe(changes_handler);
    this.on = (event_name, handler) => {
        switch (event_name) {
        case "updating":
            object_update_handler.add(handler);
            break;
        case "deleting":
            object_delete_handler.add(handler);
            break;
        case "creating":
            object_create_handler.add(handler);
            break;
        default:
            throw "unsupported json subscribe event";
        }
    };
    this.off = (event_name, handler) => {
        switch (event_name) {
        case "updating":
            object_update_handler.delete(handler);
            break;
        case "deleting":
            object_delete_handler.delete(handler);
            break;
        case "creating":
            object_create_handler.delete(handler);
            break;
        default:
            throw "unsupported json subscribe event";
        }
    };
    this.transform = () => {};
    this.reset = () => {
        for (let local_id in group) {
            delete group[local_id];
            delete objects[local_id];
        }
        for (let local_id in objects) {
            delete objects[local_id];
        }
    };
    this.publish = () => {};
    this.import = (attributes) => {
        var object = new Generic(group, {attributes, layer_name: name});
        objects[object.id] = object;
        return object;
    };
    this.remove = (local_id) => {
        if (local_id in group) {
            delete group[local_id];
            delete objects[local_id];
        }
        if (local_id in objects) {
            delete objects[local_id];
        }
    };
    this.create = (local_id, object_data) => {
        var object = new Generic(group, {
            id: local_id,
            layer_name: name,
            attributes: object_data.attributes
        });
        objects[local_id] = object;
    };
    this.update = (local_id, object_data) => {
        objects[local_id].deserialize(object_data);
    };
    this.apply_modifications = (local_id, object_data, modifications) => {
        log.debug("apply_modifications", {local_id, modifications});
        json_apply_modifications(group[local_id], "object_data.attributes", modifications);
    };
    this.restore = (object) => {
        object.change_id();
        return object;
    };
    this.duplicate = (local_id) => {
        let old_object = objects[local_id];
        let new_object = new Generic(group, {
            layer_name: name,
            attributes: old_object.serialize().attributes
        });
        return new_object;
    };
    this.dump = () => {
        let str = "{\"Layers\": \"json\",";
        for (let id in objects) {
            if (objects[id].attributes !== undefined) {
                let attributes = JSON.stringify(objects[id].attributes);
                str += `"object": {"Layer_name": "${name}", "objects_id": "${id}", "attributes": ${attributes}},`;
                //log.debug(`Layer(json)[${name}].dump objects[${id}] attributes = ${attributes}`);
            }
            else {
                str += `"object": {"Layer_name": "${name}", "object_id": "${id}"},`;
                //log.debug(`Layer(json)[${name}].dump objects[${id}] = `, objects[id]);
            }
            str += "}";
        }
        return str;
    };
};

export default Layer;
